// extracted by mini-css-extract-plugin
module.exports = {"pulseHalo":"RingOrder_pulseHalo__iKnHb","new-course-halo":"RingOrder_new-course-halo__qU26J"};